import { DOMUtils } from '../../../../utils/dom'
import { IExtendedAccessServiceAdapter } from '../adapter'
export class ExtendedAccessService implements IExtendedAccessServiceAdapter {

    public urlSwg = 'https://news.google.com/swg/js/v1/swg.js'
    public urlSwgGaa = 'https://news.google.com/swg/js/v1/swg-gaa.js'
    public urlGsiClient = 'https://accounts.google.com/gsi/client'

    public async init() {
        await DOMUtils.ready
        this.loadGoogleLibraries()
    }

    public loadGoogleLibraries() {
        DOMUtils.loadScript(this.urlSwg, [{
            key: 'subscriptions-control',
            value: 'manual'
        }])
        DOMUtils.loadScript(this.urlSwgGaa)
        DOMUtils.loadScript(this.urlGsiClient)
    }
}
